module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/store_images/2@2x_c582d74ce51ead7762cb1e82d309f14b.png";